"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const images_1 = require("../../../services/images");
const RequestDedicatedRowWeb = ({ passengersCount }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsx)("div", { className: "box-narrow", children: (0, jsx_runtime_1.jsxs)("p", { className: "font-14-400 iconed", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.DedicatedFlightCircled, alt: "" }), `${t("details.dedicated_flight")} - ${passengersCount} ${t(passengersCount === 1 ? 'overview.passenger' : 'overview.passengers')}`] }) }));
};
exports.default = RequestDedicatedRowWeb;
